import { api } from '../api.js';
import { el, fragment } from '../dom.js';
import { t, seriesLabel, upcomingLabel } from '../i18n.js';
import { institutionAvatar } from './institution-scope.js';
import { openInstitutionForm } from './institution-form.js';

// The door into the professional area, and deliberately a door rather than a
// section on a page somebody already opens.
//
// Somebody who saves a few nights and posts the occasional thing of their own
// is not a venue and should never have to decide whether they are. An empty
// "Institutionen" heading under their own programme asked exactly that, every
// time they looked at it — so this lives at its own address, the navigation
// offers it only once there is something behind it, and the way in is a
// sentence on the public site aimed at people who run something.
//
// Which is why the empty state is nearly bare: one line about what an
// institution is for, and one button. A landing page that argues is a landing
// page for a product nobody asked about yet.
export async function renderInstitutions() {
  const accounts = await api.get('/accounts');
  const institutions = accounts.filter((row) => !row.isSelf);

  const create = el('button', { class: 'button', type: 'button' }, t.newInstitution);
  create.addEventListener('click', () => openInstitutionForm({
    onCreated: (account) => window.location.assign(`/panel/i/${account.slug}`),
  }));

  if (institutions.length === 0) {
    return fragment([
      el('h1', { class: 'pub-title' }, t.institutionsTitle),
      el('p', { class: 'pub-lede' }, t.institutionsLede),
      el('p', { class: 'row' }, [create]),
    ]);
  }

  return fragment([
    el('h1', { class: 'pub-title' }, t.institutionsTitle),
    el('p', { class: 'pub-lede' }, t.institutionsLede),
    el('ul', { class: 'card-list' }, institutions.map(card)),
    el('p', { class: 'row' }, [create]),
  ]);
}

// Cards, not a switcher. Each leads into a workspace of its own, which is what
// an institution has that a tab in a picker does not: a programme, a page, an
// identity and a team.
function card(row) {
  return el('li', {}, [
    el('a', { class: 'card', href: `/panel/i/${row.slug}` }, [
      el('span', { class: 'row' }, [institutionAvatar(row), el('h3', { class: 'card-title' }, row.name)]),
      el('p', { class: 'card-meta' },
        [row.cityName, `tba.tips/${row.slug}`, row.role === 'owner' ? t.owner : t.editor]
          .filter(Boolean).join(' · ')),
      el('p', { class: 'card-meta' },
        `${seriesLabel(row.seriesCount)} · ${upcomingLabel(row.upcomingCount)}`),
    ]),
  ]);
}
